import React from 'react';
import PropTypes from 'prop-types';

import {Dialog, DialogActions, DialogContent, DialogTitle, Button, Box} from 'views/components';
import {Dropdown, DropdownMenuItem} from 'views/components';
import {Translate, translate} from 'views/module';

const CaregiverStatusEdit = (props) => {
  const [newStatus, setNewStatus] = React.useState('');

  const {
    caregiverData,
    caregiverBackend,
    isEditing,
    setIsEditing,
  } = props;

  const {status} = caregiverData;

  React.useEffect(() => {
    setNewStatus(status);
  }, [status]);

  const onSave = () => {
    caregiverBackend.detail.editStatus(newStatus, () => {
      setIsEditing(false);
    });
  };

  const onClose = () => {
    setIsEditing(false);
  };

  const allStatus = translate('caregiver.Status');

  return (
    <Dialog onClose={onClose} open={isEditing}>
      <DialogTitle onClose={onClose}>
        <Translate expression='caregiver.CaregiverDetail.ChangeStatusDailog.Title' />
      </DialogTitle>
      <DialogContent>
        <Box sx={{m: 1}}>
          <Dropdown
            value={newStatus}
            onChange={setNewStatus}
            label={translate('caregiver.CaregiverDetail.ChangeStatusDailog.Status')}
          >
            {
              Object.entries(allStatus).map(([key, value]) => (
                <DropdownMenuItem key={key} value={key}>
                  {value.Title}
                </DropdownMenuItem>
              ))
            }
          </Dropdown>
        </Box>
      </DialogContent>
      <DialogActions>
        <Button variant='outlined' onClick={onClose}>
          <Translate expression='generic.Close' />
        </Button>
        <Button color="error" onClick={onSave}>
          <Translate expression='generic.Save' />
        </Button>
      </DialogActions>
    </Dialog>
  );
};

CaregiverStatusEdit.propTypes = {
  caregiverData: PropTypes.object.isRequired,
  caregiverBackend: PropTypes.object.isRequired,
  isEditing: PropTypes.bool.isRequired,
  setIsEditing: PropTypes.func.isRequired,
};

export default React.memo(CaregiverStatusEdit);
